import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { RedirectionTypeEnumValues } from "@/types";

dayjs.extend(utc);
dayjs.extend(timezone);
import "dayjs/locale/nb";
import "dayjs/locale/da";

// Maps API base language codes to our i18n bundle keys
const API_TO_I18N: Record<string, string> = {
  da: "dk",
  no: "nb",
};

// Maps i18n bundle keys to dayjs locale codes where they differ
const I18N_TO_DAYJS: Record<string, string> = {
  dk: "da",
};

function toI18nKey(code: string): string {
  const base = code.split("-")[0];
  return API_TO_I18N[base] ?? base;
}

interface I18n {
  changeLanguage: (lng: string) => void;
}

export function changeLocale(locale: string, i18n: I18n, timeZone?: string): void {
  const lngKey = toI18nKey(locale);
  dayjs.locale(I18N_TO_DAYJS[lngKey] ?? lngKey);

  if (timeZone) {
    dayjs.tz.setDefault(timeZone);
  } else {
    dayjs.tz.setDefault(); // reset to system default when no timezone is given
  }

  i18n.changeLanguage(lngKey);
  localStorage.setItem("lng", lngKey);
}

export const getLocale = (): string | null => {
  const localeString = localStorage.getItem("lng");
  if (!localeString) return null;
  dayjs.locale(I18N_TO_DAYJS[localeString] ?? localeString);
  return localeString;
};

export const getToken = (): string | null => {
  const tokenString = localStorage.getItem("token");
  if (!tokenString) return null;
  return JSON.parse(tokenString);
};

export const saveUserToken = (userToken?: string) => {
  if (userToken === null) localStorage.removeItem("token");
  else localStorage.setItem("token", JSON.stringify(userToken));
  return userToken;
};

export const removeUserToken = () => localStorage.removeItem("token");

export const getUserContextIds = () => {
  const tokenString = localStorage.getItem("current");
  if (!tokenString) return null;
  return JSON.parse(tokenString);
};

export const setUserContextIds = (userContextIds: { userId: number; companyId: number | null }) => {
  if (userContextIds === null) localStorage.removeItem("current");
  else localStorage.setItem("current", JSON.stringify(userContextIds));
  return userContextIds;
};

export const removeUserContextIds = () => localStorage.removeItem("current");

export const getRedirection = () => {
  const tokenString = localStorage.getItem("redirection");
  if (!tokenString) return null;
  return JSON.parse(tokenString);
};

export const saveRedirectionType = (redirection: RedirectionTypeEnumValues) => {
  if (redirection === null) localStorage.removeItem("redirection");
  localStorage.setItem("redirection", JSON.stringify(redirection));
  return redirection;
};

export const removeRedirection = () => localStorage.removeItem("redirection");
